import React from "react";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { Checkbox, FormControlLabel, IconButton, Tooltip } from "@mui/material";

export const forceUpdateTooltipText =
  "Force update overwrites team-customized RVG event and session names with the EMS values for this update.";

type ForceUpdateControlProps = {
  checked: boolean;
  onChange: (checked: boolean) => void;
};

export const ForceUpdateControl: React.FC<ForceUpdateControlProps> = ({
  checked,
  onChange,
}) => {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
      }}
    >
      <FormControlLabel
        control={
          <Checkbox
            checked={checked}
            onChange={(_, isChecked) => onChange(isChecked)}
            name="forceOverwriteCustomizedNames"
          />
        }
        label="Force update"
      />
      <Tooltip title={forceUpdateTooltipText}>
        <IconButton
          aria-label="Force update information"
          size="small"
          sx={{ marginLeft: "-0.5rem" }}
        >
          <InfoOutlinedIcon fontSize="inherit" />
        </IconButton>
      </Tooltip>
    </div>
  );
};
